<template>
    <div class="grid grid-cols-1 lg:grid-cols-2 items-start p-0 m-0">
        <div class="contents lg:block">
            <div class="order-first min-w-0">
                <Carousel/>
                <QuickLinks/>
            </div>
            <div class="order-last min-w-0">
                <QuickHeadings/>
                <QuickSupport/>
                <Currency/>
            </div>
        </div>
        <div class="min-w-0">
            <SelectDepartment @departmentChange="onDepartmentChange"/>
            <Products :department="department" :type="'promotions'"/>
        </div>
    </div>

</template>
<script>
import Carousel from "../components/sections/Carousel";
import QuickHeadings from "../components/sections/QuickHeadings";
import QuickSupport from "../components/sections/QuickSupport";
import Products from "../components/sections/Products";
import SelectDepartment from "../components/sections/SelectDepartment";
import Currency from "../components/sections/Currency";
import QuickLinks from "../components/sections/QuickLinks";

export default {
    name: "HomePage",
    data: () => ({
        department: 1,
    }),
    components: {
        QuickLinks,
        Currency,
        QuickSupport,
        QuickHeadings,
        Carousel,
        Products,
        SelectDepartment,
    },
    methods: {
        onDepartmentChange(depId) {
            this.department = depId;
        }
    }
}
</script>
